import { ButtonProps } from '@mui/material';
import { forwardRef } from 'react';

import ButtonWrapper from '../../wrappers/ButtonWrapper';

const AtomButton = forwardRef<HTMLButtonElement, ButtonProps>(({ children, ...props }, ref) => (
  <ButtonWrapper ref={ref} {...props}>
    {children}
  </ButtonWrapper>
));

AtomButton.displayName = 'AtomButton';

export default AtomButton;
